import Env from '../base/env';
import Component from 'gia/Component';
import { RevealFade } from '../fx/Common'

export default class FxModule extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element

    //? Fns
    setTimeout(() => {
      RevealFade(this.DOM.view)
    }, Env.timingDelayFx);
  }
}
